import { grey } from '@mui/material/colors';

const styles = theme => ({
  dialog: {
    padding: '0px 24px',
    '&:first-child': {
      paddingTop: 0,
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  yearPicker: {
    width: '60px',
  },
  eventInfo: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    '& > *': {
      marginRight: theme.spacing(2),
    },
  },
  events: { display: 'flex', flexDirection: 'column' },
  eventContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: grey[300],
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  event: { display: 'flex', justifyContent: 'space-between' },
  arrivalDepature: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  flight: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
    padding: theme.spacing(1),
    '&:first-child': {
      marginBottom: theme.spacing(0.5),
    },
    '&:last-child': {
      marginTop: theme.spacing(0.5),
    },
    '& > *': {
      marginRight: theme.spacing(2),
    },
  },
  period: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  range: {
    display: 'flex',
    '& > *': {
      marginRight: theme.spacing(2),
    },
  },
  datePicker: {
    maxWidth: '145px',
  },
  subtitle: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '130px',
    padding: theme.spacing(1),
  },
  timePicker: {
    maxWidth: '120px',
  },
  deleteButton: {
    marginTop: theme.spacing(1),
  },
});

export default styles;
